import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/trade-federation': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8.8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 491.6c129.7 0 234.8-105.1 234.8-234.8s-105.1-234.8-234.8-234.8-234.8 105.1-234.8 234.8 105.1 234.8 234.8 234.8zM403.1 163.1v0.1h-145.7v34.8h83.3v47h-83.3v195.8h-48.8v-196.8h-117.7l-36.7-46h155.1v-81.7h193.8v46.8zM329.8 208.2h-82.9v-56.2h145v-24.4h-171.8v80.6h-143.9l20.1 23.9h123.8v197.4h26.8v-197.4h82.9v-23.9zM168.5 139.2l22-9.3-15.8 18.1 15.7 18.1-22.2-9.5-12.3 20.5 2.1-24-23.3-5.4 23.5-5.4-2.1-23.8zM138.9 119.5l9.5 10.2-13.8-5.3-6.8 12.2 0.8-14.7-13.7-2.7 14.3-3.8-1.7-13.9 8 12.4 12.7-5.9zM304.3 264.7l-9.3 10.8 9.4 10.7-13.1-5.5-7.3 12.2 1.2-14.2-13.9-3.2 13.9-3.2-1.3-14.2 7.3 12.2zM411.2 187.5l-15 17.6 15.1 17-21.2-8.8-11.5 19.6 1.8-22.9-22.2-4.9 22.3-5.4-2.2-22.7 12 19.6zM248 29.9c125.3 0 226.9 101.6 226.9 226.9s-101.6 226.9-226.9 226.9-226.9-101.6-226.9-226.9 101.6-226.9 226.9-226.9zM342.6 196h-83.2v-30.9h145.7v-50.7h-197.8v81.6h-157.4l40 49.9h116.7v196.8h52.7v-195.7h83.3v-51zM248 43.2c-94.6 0-174.9 61.6-202.9 146.8h157.4v-81.6h199.1c-38.8-40.2-93.3-65.2-153.6-65.2zM248 470.3c117.9 0 213.5-95.6 213.4-213.5 0-51.9-18.5-99.5-49.3-136.5v50.8h-145.6v19.2h83.2v62.7h-83.3v195.8h-64.6v-196.8h-114.7l-43.8-56.3c-5.8 19.3-8.9 39.9-8.9 61.1 0 117.9 95.7 213.5 213.6 213.5zM178.8 275l22.7-9.3-16.9 17.1 15.8 18.8-21.5-10.8-13 20.9 3.7-23.8-23.8-5.9 23.7-3.9-1.7-24.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/trade-federation.js
// module id = 1054
// module chunks = 0